module.exports = __webpack_public_path__ + "static/img/study.966c876.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/me-history/study.png
// module id = uNiu
// module chunks = 1